import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/logo-getit.png';
import BrandLogo from '../common/BrandLogo';

const WelcomeScreen = ({ onStart }) => {
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(false);
    const [pulse, setPulse] = useState(false);
    const [isExiting, setIsExiting] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 100);

        const pulseInterval = setInterval(() => {
            setPulse(true);
            setTimeout(() => setPulse(false), 1000);
        }, 3000);

        return () => {
            clearTimeout(timer);
            clearInterval(pulseInterval);
        };
    }, []);

    const handleStart = () => {
        setIsExiting(true);
        setTimeout(() => {
            if (onStart) {
                onStart();
            } else {
                navigate('/products');
            }
        }, 500);
    };

    return (
        <div className={`welcome-screen ${isExiting ? 'exiting' : ''}`}>
            <BrandLogo delay={0.5} />

            <div className={`content ${isVisible ? 'visible' : ''}`}>
                <div className="logo-section">
                    <div className="logo-container">
                        <img src={logo} alt="GetIT" className="logo" />
                    </div>
                </div>

                <div className="cta-section">
                    <h1 className="welcome-title">¡Bienvenido!</h1>
                    <p className="welcome-subtitle">Comida rápida de calidad</p>
                    <button
                        onClick={handleStart}
                        className={`order-button ${pulse ? 'pulse' : ''}`}
                    >
                        Comenzar mi Pedido
                    </button>
                </div>
            </div>

            <style>{`
                .welcome-screen {
                    position: fixed;
                    inset: 0;
                    z-index: 50;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    overflow: hidden;
                    background: linear-gradient(135deg, #0E8164 0%, #0a6b52 100%);
                    transition: opacity 0.5s ease-out, transform 0.5s ease-out;
                }

                .welcome-screen.exiting {
                    opacity: 0;
                    transform: scale(1.05);
                }

                .content {
                    position: relative;
                    z-index: 10;
                    text-align: center;
                    width: 100%;
                    max-width: 75rem;
                    height: 100vh;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-evenly;
                    padding: 4rem 3rem;
                    opacity: 0;
                    transform: scale(0.95);
                    transition: all 1s cubic-bezier(0.34, 1.56, 0.64, 1);
                }

                .content.visible {
                    opacity: 1;
                    transform: scale(1);
                }

                .logo-section {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .logo-container {
                    background: white;
                    padding: 4rem 6rem;
                    border-radius: 3rem;
                    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
                    animation: logo-entrance 1.2s ease-out 0.3s both;
                }

                .logo {
                    width: 100%;
                    max-width: 45rem;
                    height: auto;
                    display: block;
                }

                .cta-section {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 2rem;
                    animation: cta-entrance 1s ease-out 0.6s both;
                }

                .welcome-title {
                    font-size: 5.5rem;
                    color: white;
                    font-weight: 700;
                    margin: 0;
                    font-family: 'Quicksand', sans-serif;
                    letter-spacing: -0.02em;
                    text-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
                }

                .welcome-subtitle {
                    font-size: 2rem;
                    color: rgba(255, 255, 255, 0.95);
                    font-weight: 500;
                    margin: 0;
                    font-family: 'Quicksand', sans-serif;
                    letter-spacing: 0.02em;
                }

                .order-button {
                    background: white;
                    color: #0E8164;
                    padding: 2.5rem 7rem;
                    font-size: 2.5rem;
                    font-weight: 700;
                    border-radius: 2rem;
                    border: none;
                    cursor: pointer;
                    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
                    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
                    font-family: 'Quicksand', sans-serif;
                    margin-top: 1rem;
                    min-width: 40rem;
                }

                .order-button:hover {
                    transform: translateY(-4px) scale(1.02);
                    box-shadow: 0 25px 60px rgba(0, 0, 0, 0.4);
                }

                .order-button:active {
                    transform: translateY(-2px) scale(1);
                }

                .order-button.pulse {
                    animation: pulse-button 1.2s ease-in-out;
                }

                @keyframes logo-entrance {
                    0% {
                        opacity: 0;
                        transform: scale(0.9) translateY(-20px);
                    }
                    100% {
                        opacity: 1;
                        transform: scale(1) translateY(0);
                    }
                }

                @keyframes cta-entrance {
                    0% {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    100% {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @keyframes pulse-button {
                    0%, 100% {
                        transform: scale(1);
                    }
                    50% {
                        transform: scale(1.05);
                    }
                }
            `}</style>
        </div>
    );
};

export default WelcomeScreen;